import styled from 'styled-components';
import { BasketSelectSectionStyled } from '../BasketSeclectSectionStyled';
import { rem } from 'polished';

export const BasketSeclectSectionOV = styled(BasketSelectSectionStyled)`
    .sections {
        .leftSection,
        .rightSection {
            &:hover,
            &:focus-visible {
                background: ${({ theme }) => theme.colors.pureWhite};
                border: 1px solid ${({ theme }) => theme.colors.primaryHover};
                
                .inner {
                    border: 1px solid ${({ theme }) => theme.colors.primaryHover};
                }
            }
            
            &.selected {
                border-color: ${({ theme }) => theme.colors.primaryHover};
                background: ${({ theme }) => theme.colors.grey10};
                
                .inner {
                    border-color: ${({ theme }) => theme.colors.primaryHover};
                }
            }
            
            .title {
                font-size: ${({ theme }) => theme.fontSizes.textMedium};
                
                .icon {
                    &.selected {
                        background: ${({ theme }) => theme.colors.primary};
                        border-color: ${({ theme }) => theme.colors.primary};
                        
                        .selected {
                            background: ${({ theme }) => theme.colors.primaryHover};
                        }
                    }
                }
            }
            
            .description {
                font-size: ${({ theme }) => theme.fontSizes.textSubMedium};
                color: ${({ theme }) => theme.colors.grey28};
            }
        }
    }
`;
